import { render } from "./Assessement.vue?vue&type=template&id=23d6545c&scoped=true"
import script from "./Assessement.vue?vue&type=script&lang=js"
export * from "./Assessement.vue?vue&type=script&lang=js"

import "./Assessement.vue?vue&type=style&index=0&id=23d6545c&scoped=true&lang=scss"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d6545c"]])

export default __exports__